var _g, _g2, _g3, _g4, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndustrySalonHeroGradient9Aee5741Fb52F24C8319F20Cac18D941(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2007,
    height: 1477,
    viewBox: "0 0 2007 1477",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_19459_99651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M972.8 989.373L746.321 1050.01L685.689 823.526L912.168 762.894L972.8 989.373Z",
    fill: "#001AFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_19459_99651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.416 1014.5C348.536 949.623 348.536 844.431 413.416 779.551C478.297 714.67 583.488 714.67 648.369 779.551C713.249 844.431 713.249 949.623 648.369 1014.5C583.488 1079.38 478.297 1079.38 413.416 1014.5Z",
    fill: "#00C2FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_19459_99651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M857.334 742.675L701.215 663.128L577.317 787.025L604.727 613.965L448.608 534.419L621.668 507.009L649.078 333.949L728.625 490.068L901.685 462.658L777.787 586.555L857.334 742.675Z",
    fill: "#DB00FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_19459_99651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.749 918.456L333.94 481.724L912.065 353.845L733.749 918.456Z",
    fill: "#FE9A9A"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_19459_99651)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 331.782,
    cy: 233.978,
    rx: 331.782,
    ry: 233.978,
    transform: "matrix(0.985464 0.169886 -0.127789 0.991801 1103.01 297.677)",
    fill: "#AA1FFF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_19459_99651)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.508,
    cy: 420.939,
    rx: 336.508,
    ry: 420.939,
    transform: "matrix(0.258819 0.965926 -0.949327 0.314289 1477.16 312.185)",
    fill: "#FF94EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_19459_99651",
    x: 352.355,
    y: 429.56,
    width: 953.778,
    height: 953.779,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 166.667,
    result: "effect1_foregroundBlur_19459_99651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_19459_99651",
    x: 31.4227,
    y: 397.557,
    width: 998.94,
    height: 998.94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 166.667,
    result: "effect1_foregroundBlur_19459_99651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_19459_99651",
    x: 115.274,
    y: 0.615143,
    width: 1119.74,
    height: 1119.74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 166.667,
    result: "effect1_foregroundBlur_19459_99651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_19459_99651",
    x: 0.606232,
    y: 20.5116,
    width: 1244.79,
    height: 1231.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 166.667,
    result: "effect1_foregroundBlur_19459_99651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_19459_99651",
    x: 800.893,
    y: 76.4057,
    width: 1198.36,
    height: 1019.39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 135.417,
    result: "effect1_foregroundBlur_19459_99651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_19459_99651",
    x: 575.011,
    y: 237.941,
    width: 1179.26,
    height: 1063.16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90.2778,
    result: "effect1_foregroundBlur_19459_99651"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustrySalonHeroGradient9Aee5741Fb52F24C8319F20Cac18D941);
export default __webpack_public_path__ + "static/media/Industry_Salon_Hero_Gradient-9aee5741fb52f24c8319f20cac18d941.9aee5741fb52f24c8319f20cac18d941.svg";
export { ForwardRef as ReactComponent };